'use strict';

const html2Canvas = require('html2canvas');
const damHelper = require('../dam/dam-helper');
const singlePageCheckout = require('../pages/checkout/singlepagecheckout');
const imageTypes = {
    PRODUCT: 'product',
    ORDEROVERVIEW: 'orderoverview',
    GIFT: 'gift'
};

const init = () => {
    $(document).off('click.socialcommerce').on('click.socialcommerce', '.js-social-commerce-button', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        if ($this.hasClass('button-loading')) {
            return;
        }
        const data = $this.data('social-commerce');
        if (!data) {
            return;
        }
        bindLineItemData($this, data);

        toggleSpinner($this, true);

        handleImageSending(data, $this);
    });

    $(document).on('click', '.js-social-commerce-send-link-button', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(e.target);
        if ($this.hasClass('button-loading')) {
            return;
        }
        toggleSpinner($this, true);

        const $activeStep = $(document).find('.checkout-step-btn.current');

        if ($activeStep.hasClass('js-step-1')) {
            if (singlePageCheckout.submitInformationForm(e, null, null, sendCheckoutLink) == false) {
                sendCheckoutLink($this, 1);
            }
        } else if ($activeStep.hasClass('js-step-2')) {
            sendCheckoutLink($this, 2);
        } else if ($activeStep.hasClass('js-step-3')) {
            sendCheckoutLink($this, 3);
        }
    });

    $(document).on('click', '.js-social-commerce-cancel-order', function () {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.SC_CANCEL_ORDER_HEADER,
                headingLarge: true,
                headingNarrow: true
            },
            paragraphs: [{
                text: window.Resources.SC_CANCEL_ORDER_TEXT,
                textColorBlack: true,
                textWidthLimiter: true
            }],
            ctaHolder: {},
            buttons: [{
                    type: 'btn btn-full-wdth',
                    label: window.Resources.SC_CANCEL_ORDER_BUTTON_NO,
                    shouldCloseModal: true
                },
                {
                    type: 'btn btn-full-wdth btn--secondary',
                    label: window.Resources.SC_CANCEL_ORDER_BUTTON_YES,
                    eventName: 'onSoSCancelOrderButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                shouldCloseModal: true
            },
            modalSmall: true,
            centerOnMobile: true
        });
    });

    window.eventBus.$on('onSoSCancelOrderButtonClick', function () {
        $.ajax({
            url: Urls.cancelOrder,
        }).done(function () {
            window.location.href = window.Urls.cartShow;
        });
    });
};

const sendCheckoutLink = ($this, step) => {
    const promise = $.Deferred();

    const socialCommerceCheckoutLinkConfig = $this.data('social-commerce-checkout-link-config');

    if (socialCommerceCheckoutLinkConfig && socialCommerceCheckoutLinkConfig.shouldSendOrderOverview) {
        handleImageSending(socialCommerceCheckoutLinkConfig.data, $this)
                .then(() => { promise.resolve(); });
    } else {
        promise.resolve();
    }

    const currentUrl = JSON.parse(JSON.stringify({
        url: window.location.href,
        step: step
    }));
    // Always send checkout link.
    $.when(promise).always(() => {
        $.ajax({
            url: Urls.getCheckoutLink,
            data: currentUrl
        }).done(function (response) {
            if (response.error) {
                toggleSpinner($this, false);
                errorView.show(response, () => {
                    sendCheckoutLink($this, step);
                });
                return;
            }

            toggleSpinner($this, true, true);
        });
    });
};

const handleImageSending = (data, $this) => {
    // There are a lot of asyncronous calls on this flow and $.ajax resolves as soon as the request is done.
    // so using a Deferred to handle the flow.
    const promise = $.Deferred();

    $.ajax({
        url: getUrl(data),
        data: data
    }).done((responseHTML) => {
        const $info = $(responseHTML).filter(getCssClass(data));
        if (!$info || !$info.length) {
            toggleSpinner($this, false);
            return;
        }

        takePictureAndUpload($this, $info[0], data.pid, data.configurationId, getImageType(data))
            .then(() => { promise.resolve(); });
    });

    return promise;
};

const getCssClass = (data) => {
    if (data.isOrderOverview) {
        return '.js-social-commerce-cart-info';
    }
    return '.js-social-commerce-product-info';
};

const getUrl = (data) => {
    if (data.isOrderOverview) {
        return Urls.getCartViewToCapture;
    }
    return Urls.getViewToCapture;
};

const getImageType = (data) => {
    if (data.isOrderOverview) {
        return imageTypes.ORDEROVERVIEW;
    }
    return data.isGift ? imageTypes.GIFT : imageTypes.PRODUCT;
};

const toggleSpinner = (button, showSpinner, shouldShowCheckmark) => {
    if (!button) {
        return;
    }

    if (button && $.isFunction(button)) {
        button(showSpinner, shouldShowCheckmark);
        return;
    }

    const $socialCommerceButtonSpinner = $('.js-social-commerce-spinner', button);
    $socialCommerceButtonSpinner.removeClass('spinner-visible');
    button.removeClass('send-icon-visible');
    button.removeClass('button-loading');
    if (!showSpinner) {
        return;
    }

    button.addClass('button-loading');
    if (shouldShowCheckmark) {
        button.addClass('send-icon-visible');
    } else {
        $socialCommerceButtonSpinner.addClass('spinner-visible');
    }
    setTimeout(function () {
        toggleSpinner(button, false, shouldShowCheckmark);
    }, 30000);
};

const takePictureAndUpload = (button, element, productId, configurationId, imageType) => {
    const options = {
        allowTaint: true,
        useCORS: true,
        logging: true,
        scale: 2
    };

    element = document.body.appendChild(element);
    damHelper.updateImages(element);

    const promise = $.Deferred();
    $(element).imagesLoaded().always(() => {
         const canvasPromise = html2Canvas(element, options)
            .then(canvas => {
                element.remove();
                const dataUrl = canvas.toDataURL();
                const strippedDataUrl = dataUrl.substr(dataUrl.indexOf(',') + 1); // strip the begining part of dataUrl "data:image/png;base64,"
                const formData = new FormData();
                formData.append('imageContent', new Blob([Buffer.from(strippedDataUrl, 'base64')], { /* eslint-disable-line */
                    type: 'image/jpeg'
                }));
                formData.append('productId', productId);
                formData.append('imageType', imageType);
                if (configurationId) {
                    formData.append('configurationId', configurationId);
                }
                return uploadImageAndSendDataToMulesoft(button, formData);
            });

        canvasPromise.finally(() => { promise.resolve(); });
    });

    return promise;
};

const uploadImageAndSendDataToMulesoft = (button, formData) => {
    return $.ajax({
        url: Urls.uploadImageAndSendDataToMulesoft,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
    }).done(function (response) {
        if (!response || response.error) {
            toggleSpinner(button, false);
            errorView.show(response, () => {
                uploadImageAndSendDataToMulesoft(button, formData);
            });
            return;
        }

        toggleSpinner(button, true, true);
    });
};

const errorView = {
    show: (data, callbackFunction) => {
        const firstButtonData = {
            type: 'btn btn-full-wdth',
            label: data.firstButtonLabel,
            shouldCloseModal: true,
            eventName: data.closePopupEvent || 'onCloseElementClick'
        };
        let secondButtonData = null;
        if (data.secondButtonLabel) {
            firstButtonData.eventName = 'onResendLinkButtonClick';
            secondButtonData = {
                type: 'link link--large',
                label: data.secondButtonLabel,
                shouldCloseModal: true
            };
        }
        const closePopupEvent = data.closePopupEvent || 'onCloseElementClick';

        const buttons = [firstButtonData, secondButtonData].filter(Boolean);

        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: data.title,
                headingLarge: true,
                headingNarrow: true
            },
            paragraphs: [{
                text: data.errorMessage,
                textColorBlack: true
            }],
            closeElement: {
                eventName: closePopupEvent,
                shouldCloseModal: true
            },
            row: {
                rowWidth: 'row-full-width'
            },
            modalSmall: true,
            ctaHolder: {},
            buttons: buttons,
            centerOnMobile: true
        });

        window.eventBus.$once('onResendLinkButtonClick', () => {
            if (callbackFunction && $.isFunction(callbackFunction)) {
                callbackFunction();
            }
        });

        window.eventBus.$once('onSwitchSessionModalClick', () => {
            window.close();
        });
    }
};

const updateCustomerLastUrl = () => {
    const isSocialCommerceEnabled = !!$('.js-social-commerce-banner').length;
    if (!isSocialCommerceEnabled) {
        return;
    }

    $.ajax({
        url: Urls.saveCustomerUrl,
        type: 'POST',
        data: {
            customerLastUrl: location.href
        }
    });
};

const bindLineItemData = (target, socialCommerceData) => {
    const $lineItemRow = target.closest('.js-cart-row');
    if (!$lineItemRow.length) {
        return;
    }

    socialCommerceData.lineItemUuid = $lineItemRow.data('uuid');
};

const showSwitchSessionModal = () => {
    const params = {
        firstButtonLabel: window.Resources.SC_SWITCH_SESSION_BUTTON,
        title: window.Resources.SC_SWITCH_SESSION_HEADER,
        errorMessage: window.Resources.SC_SWITCH_SESSION_TEXT,
        closePopupEvent: 'onSwitchSessionModalClick'
    };

    errorView.show(params);
};

module.exports = {
    init: init,
    handleImageSending: handleImageSending,
    errorView: errorView,
    updateCustomerLastUrl: updateCustomerLastUrl,
    showSwitchSessionModal: showSwitchSessionModal
};
